import axios from "axios";
import axiosInstance from "../api/axios";

export const saveBudget = async (payload) => {
  const res = await axiosInstance.post(`/api/user/save-budget`, payload);
  return res.data;
};

export const getDashboardDetails = async (payload) => {
  const res = await axiosInstance.post(`/api/user/dashboard`, payload);
  return res.data;
};

export const fetchExchangeRates = async () => {
  const res = await axios.get(`https://api.exchangerate-api.com/v4/latest/CAD`);
  return res.data;
};
export const downloadReport = async (payload) => {
  const res = await axiosInstance.post("/api/user/download-pdf", payload);
  return res.data;
};
